module.exports = "Ext.namespace(\"SF\"),SF.StatefulTabMixin={getState:function(){var t=this.getActiveTab();return{activeTab:t?t.getId():void 0}}};"